<script setup>
import { useTheme } from 'vuetify'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@core/utils/colorConverter'
import { useAuthStore } from '@/stores/auth'

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()

// Modul C (addendum 04 §3): cookie userAbilityRules cuma dibaca sekali oleh
// plugins/casl/index.js saat boot, tidak pernah di-refresh -> kalau role user
// diubah di backend tanpa logout, ability di browser tetap yang lama sampai
// cookie dihapus manual. fetchUser() di sini menyegarkan ability dari backend
// setiap kali app di-boot/di-refresh, hanya kalau user memang sedang login.
const authStore = useAuthStore()
if (useCookie('accessToken').value)
  authStore.fetchUser()
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
